import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import { Comment } from './comment';
export var AnswerComment = /*#__PURE__*/function (_Entity) {
  _inherits(AnswerComment, _Entity);

  var _super = _createSuper(AnswerComment);

  function AnswerComment() {
    _classCallCheck(this, AnswerComment);

    return _super.apply(this, arguments);
  }

  _createClass(AnswerComment, [{
    key: "submissionAnswerContent",
    get: function get() {
      return this.props.submissionAnswerContent;
    }
  }, {
    key: "comments",
    get: function get() {
      return this.props.comments;
    }
  }, {
    key: "updateSubmissionAnswerContent",
    value: function updateSubmissionAnswerContent(updatedContent) {
      this.props.submissionAnswerContent = updatedContent;
    }
  }, {
    key: "addComment",
    value: function addComment(commentContent, commentId, submissionAnswerContent) {
      if (!this.props.comments) {
        return new BadInputError('Answer Comments is not defined');
      }

      if (!this.props.submissionAnswerContent) {
        this.props.submissionAnswerContent = submissionAnswerContent;
      }

      var itemCommentOrError = Comment.create({
        content: commentContent
      }, commentId);

      if (itemCommentOrError.isFailure) {
        return Result.fail(itemCommentOrError.error);
      }

      this.updateSubmissionAnswerContent(submissionAnswerContent);
      this.props.comments.push(itemCommentOrError.getValue());
      return Result.ok();
    }
  }, {
    key: "editComment",
    value: function editComment(commentContent, commentId) {
      if (!this.props.comments) {
        return;
      }

      var comment = this.props.comments.find(function (c) {
        return c.id.toString() === commentId;
      });

      if (comment) {
        comment.updateContent(commentContent);
      }
    }
  }, {
    key: "deleteComment",
    value: function deleteComment(commentId) {
      if (!this.props.comments) {
        return;
      }

      this.props.comments = this.props.comments.filter(function (comment) {
        return comment.id.toString() !== commentId;
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.submissionAnswerContent,
        argumentName: 'Submission Answer Content'
      }, {
        argument: props.comments,
        argumentName: 'Answer Comments'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var submissionSummary = new AnswerComment(props, new UniqueEntityID());
      return Result.ok(submissionSummary);
    }
  }]);

  return AnswerComment;
}(Entity);

_defineProperty(AnswerComment, "default", AnswerComment.create({
  submissionAnswerContent: '',
  comments: []
}).getValue());